import { copy } from "clipboard";

export default {
  /*按钮*/
  bt:{
    search:"搜索",
    query:"查询",
    operation:"操作",
    add:"新增",
    edit:"修改",
    delete:"删除",
    down:"下载",
    export:"导出",
    upload:"上传",
    enable:"启用",
    disable:"禁用",
    close:"关闭",
    view:"查看",
    confirm:"确定",
    batchUpdateSwitchCode:"批量修改通道",
    batchUpdateStatus:"批量修改状态",
    approved:"审批",
    cancel:"取消",
    copy:"复制",
    isStop:"确定禁用?",
    isEnable:"确定启用?",
    isStopRepeat:"确定开启可以重复执行任务?",
    isEnablepRepeat:"确定取消可以重复执行任务?",
    logout:"注销",
    unlock:"解锁",
     redo:"重做",
     back:"撤回"
  },
  /*公用字段或工具函数字段*/
  common:{
    startTime:"开始时间",
    endTime:"结束时间",
    creator:"创建人",
    updater:"更新人",
    createTime:"创建时间",
    updateTime:"更新时间",
    phone:"手机号",
    name:"姓名",
    email:"邮箱",
    idNumber:"身份证号码",
    status:"状态",
    remark:"备注",
  },
  /*用户追踪页面*/
  kscore:{
    month:"活动期数",
    profit:"收益",
    detail:"详情",
    symbol:'产品名称',
    direction:'买卖方向',
    openPrice:'开仓价格',
    closePrice:'平仓价格',
    createTime:'平仓时间',
  },
  registerLog:{
    dataType:"数据类型",
    driverType:"设备类型",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    utmContent:"广告组",
    utmTerm:"关键字",
    ipAddress:"IP所在地",
    href:"来源URL",
    referrer:"着陆页",
    directPhone:"推荐人手机号",
    phonePre:"手机区号",
    title:"性别",
    businessType:"业务组",
    ruleId:"短信规则id",
    register:"原始客户名单",
  },
  accountReward:{
    activeId:"活动ID",
    activeStatus:"活动状态",
    activeName:"活动名称",
    activeType:"活动类型",
    proposalNo:"提案号",
    beginDate:"活动开始时间",
    endDate:"活动结束时间",
    expDay:"有效期",
    proposalUser:"提案人",
    proposalDate:"提案时间",
    approvalUser:"审批人",
    approvalDate:"审批时间",
    proposalType:"提案类型",
    proposalStatus:"提案状态",
    applyProposal:"执行提案",
    cancelProposal:"取消提案",
    applySuccess:"执行成功",
    applyFail:"执行失败",
    choiceOne:"请选择一条提案",
    notSatisfiable:"提案不符合要求",
    haveCancelledCustomer: "提案不能包含已注销账户",
    downloadProActivity:"推荐赠金活动提案",
    excuteCustomerNumber:'会员账号',
    demo:'账户类型',
    levelType:'账户级别',
    mobilePhone:'电话',
    chineseName:'姓名',
    directPhone:'直接推荐人',
    directindirect:'直接/间接推荐人',
    indirectPhone:'间接推荐人',
    symbolType:'产品类型',
    execVolume:'交易笔数',
    complianceExecVolume:'客户交易手数/达标手数',
    complianceStatus:'达标状态',
    ctime:'达标时间',
    userCreateDate:'开户时间',
    activeTime:'激活时间',
    downloadEffectiveCustomer:'有效客户记录',
    downloadActivity:'交易返利活动',
    downloadActivity0:'推荐赠金活动',
  },
  rewardTradeDetails:{
    currentCustomerNumber:'结算账号',
    currentMobilePhone:'结算账号手机号',
    currentChineseName:'结算账号姓名',
    excuteCustomerNumber:'客户交易账号',
    mobilePhone:'客户手机号',
    demo:'账户类型',
    levelType:'账户级别',
    symbolType:'产品类型',
    symbol:'产品',
    orderid:'持仓号',
    execVolume:'交易笔数',
    relationType:'奖励类型',
    directPhone:'直接推荐人',
    indirectPhone:'间接推荐人',
    currentRebete:'金额',
    ctime:'结算时间',
    downloadTradeDetails:'奖励明细记录',
    depositStatus:'入账状态'
  },
  rewardDealList:{
    createDate:'结算时间',
    currentCustomerNumber:'结算账号',
    currentMobilePhone:'结算手机号',
    currentChineseName:'结算客户姓名',
    customerStatus:'账户状态',
    accountStatusCode:'账户状态',
    currentRebete:'奖励金额',
    correctionRebete:'调整金额',
    finalRebete:'最终返利',
    proposalStatus:'状态',
    updateUser:'修改人',
    updateDate:'修改时间',
    approvalUser:'审批人',
    approvedDate:'审批时间',
    remark:'备注(拒绝原因)',
    confirmSubmit:'确认提交',
    confirmSuccess:"提交成功",
    confirmFail:"提交失败",
    cancel:'取消',
    confirm:'确定',
    cancelProposal:'取消提案',
    refuse:'拒绝提案',
    apply:'审批',
    reason:'原因',
    limit:'额度调整表',
    refuseProposal:'拒绝',
    downloadLimit:'下载额度调整表'
  },
  relationList:{
    customerRelation:'用户推荐关系',
    customerRelationPro:'用户推荐关系提案',
    customerNum:'交易账号',
    mobilePhone:'手机号码',
    userName:'姓名',
    userLevel:'账户级别',
    createDate:'开户日期',
    activeTime:'激活时间',
    newdirectPhone:'直接推荐人',
    remark:'备注',
    customerNumber:'会员账号',
    phone:'电话',
    direct:'直接/间接推荐人',
    matchType:'推荐关系',
    activeStatus:'激活状态',
    demoCustomerNum:'模拟账号',
    directNumber:'直接推荐人账号',
    directPhone:'直接推荐人手机',
    indirectNumber:'间接推荐人账号',
    indirectPhone:'间接推荐人手机',
    inviteCode:'邀请码',
    useInviteCode:'有无邀请码',
    directInviteCode:'直接推荐人邀请码',
    reStatus:'匹配结果',
    proposalUser:'提案人',
    proposalDate:'提案时间',
    approvalUser:'审批人',
    approvalDate:'审批时间',
    applyProposal:"执行提案",
    cancelProposal:'取消提案',
    beginDate:'开户开始时间',
    endDate:'开户结束时间',
    proposalStatus:'提案状态',
    proposalNo:'提案号',
  },
  faceConfig:{
      deleteSuccess:'删除成功!',
      updateSuccess:'修改成功!',
      code:'通道编码',
      name:'通道名称',
      type:'验证类型',
      thirdParty:'第三方接口',
      cost:'费用',
      status:'状态',
      remark:'备注',
      verifyCode:'厂家通道',
      verifyType:'验证类型',
      verifyTypeCN:'验证类型中文',
      describe:'验证描述',
      device:'平台类型',
      channel: '渠道名称',
      channelDesc: '渠道名称，例如Android: cf / iOS: com.cfd.cf',
      version: '版本号',
      versionDesc: '版本号，例如Android: 111 / iOS: 1.1.1',
      switchCode: '通道切换',
      faceStatus: '人脸控制',
      createDate : '创建时间',
      createUser: '创建人',
      updateUser: '修改人',
      updateDate: '修改时间',
      submitSuccess:'操作成功',
      faceRecord:'验证记录',
      chineseName: '姓名',
      card: '身份证',
      phone: '手机号',
      recordDate: '记录时间',
      channelName : '通道名称',
      result: '比对结果',
      resultParam: '查询输出',
      count: '使用次数',
      successCount: '成功次数',
      artificialCount: '人工调用成功次数',
      systemCount: '系统调用成功次数',
      needSelectRecord: '请先选择最少一个记录',
  },
  creditLevel:{
     updateList:'信用等级修改列表',
     journal:'修改日志',
     batchImport:'批量导入',
     uploadTip:'将文件拖到此处，或',
     uploadTip1:'点击上传',
     uploadTip2:'只能上传xlsx文件，且不超过10M',
     uploadSuc:'文件上传成功',
     uploadFail:'文件上传失败',
     downTemplate:'下载模板',
     uploadFile:'立即上传',
     batchUpdate:'批量修改',
     customerNo: '会员账号',
     pkey: 'P标签',
     creditLevelOld: '修改前的信用等级',
     creditLevelOriginal: '当前用户信用等级',
     creditLevel:'信用等级',
     remark:'备注',
     createDate :'创建时间',
     createUser: '创建人',
     updateUser: '修改人',
     updateDate: '修改时间',
  },
  starLevel:{
     updateList:'星级修改列表',
     journal:'修改日志',
     batchImport:'批量导入',
     uploadTip:'将文件拖到此处，或',
     uploadTip1:'点击上传',
     uploadTip2:'只能上传xlsx文件，且不超过10M',
     uploadSuc:'文件上传成功',
     uploadFail:'文件上传失败',
     downTemplate:'下载模板',
     uploadFile:'立即上传',
     batchUpdate:'批量修改',
     customerNo: '会员账号',
     starLevelOld: '修改前的星级',
     starLevelOriginal: '当前用户星级',
     starLevel:'星级',
     remark:'备注',
     createDate :'创建时间',
     createUser: '创建人',
     updateUser: '修改人',
     updateDate: '修改时间',
     update:'修改',
     dataType:'修改类型',
  },
  rebateComponents:{
    subtotal:'小计',
    total:'总计',
    tradeLogList:'返利明细记录详情',
    cancel:'取消',
    confirm:'确认',
    symbolType:'产品类型',
    displayName:'产品',
    orderId:'持仓号',
    execVolume:'交易手数',
    rebateAmount:'返利金额',
    activeName:'活动名称',
    activity:'活动时间',
    activeId:'活动ID',
    effective:'有效客户条件设置',
    tips:'新客户开户和激活时间必须在该活动期限内',
    beginDate: "开始时间",
    endDate: "结束时间",
    expDate: "有效期起始日",
    expDay: "有效期",
    productType: "产品类型",
    me: "客户",
    direct: "直接推荐",
    indirect: "间接推荐",
    quantity: "交易手数要求",
    highAmount:'最高奖励金额',
    highAmount2:'新客户最高贡献返利',
    highPoint:'客户推荐累计获得最高返利',
    add:'新增',
    update:'修改',
    dollar:'美元',
    day:'天',
    activeTime:'激活日期',
    reward:'推荐赠金设置',
    rebate:'交易返利设置',
    addCondition:'添加条件',
    min:'MIN',
    std:'STD',
    pro:'PRO',
    vip:'VIP',
    to:'至',
    all:'全部',

  },
  risk:{
    name:"网关名称",
    baseSetting:"基础用户配置",
    specialSetting:"特定用户配置",
    ipSetting:"ip规则配置",
    addBaseSetting:"新增规则用户群",
    addspecialSetting:"新增特定用户群",
    settingTpye:"配置类型",
    userType:"用户群体",
    pkey:"P标签",
    nkey:"N标签",
    creditLevel:"信用等级",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    limitSetting:"限制规则",
  },
  registervalidate:{
    customerNo:"账号",
    registerType:"开户类型",
    target:"标签",
    creditTunnel2:"征信通道2",
    creditTunnel3:"征信通道3",
    validateStatus2:"二元素验证状态",
    validateStatus3:"三元素验证状态",
    registerStatus:"开户状态",
    channel:"渠道来源",
    kycResult:"kyc验证结果",
    personMarkTunnel:"征信诉讼通道",
    personMarkResult:"征信诉讼验证结果",
    creditLoanTunnel:"征信逾期通道",
    creditLoanResult:"征信逾期验证结果",
  },
  tracker:{
    customerNo:"用户账号",
    openStartTime:"开户开始时间",
    openEndTime:"开户结束时间",
    activeStartTime:"激活开始时间",
    activeEndTime:"激活结束时间",
    userType:"账号类型",
    isActive:"激活状态",
    isShow:"列段显示/隐藏",
    businessType:"业务组",
    relatedAccount:"关联账号",
    levelType:"账号级别",
    userAge:"年龄",
    gender:"性别",
    birthday:"出生日期",
    ctime:"开户日期",
    pkey:"P标签",
    nkey:"N标签",
    creditLevel:"信用等级",
    href:"来源url",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    utmContent:"广告组",
    utmTerm:"关键字",
    activeTime:"激活时间",
    ipAddress:"IP所在地",
    userAgent:"浏览器",
    checkStatus:"IVI验证状态",
    arbitrageurTags:"IVI验证标记",
    directAccount:"推荐人帐号",
    directPhone:"推荐人手机号",
    tracker:"用户追踪",
    inviteCode:'邀请码',
    isInviteCode:'有无邀请码',
    directInviteCode:'推荐人邀请码',
    groupName:"組名",
  },
  activeTemplate:{
    type:"活动类型",
    url:"发布域名",
    detail:"模块模板",
    field:"广告属性",
    fieldTitle:"属性名称",
    fieldField:"属性编码",
    fieldType:"属性类型",
    text:"文字",
    img:"图片",
    title:"模板标题",
    activeTime:"活动时间",
    author:"发布人",
  },
  advertising:{
    advertisingStats: "广告数据统计",
    key: "键",
    value: "值",
    type: "类型",
    adverType: "类型",
    adverId: "广告id",
    account: "用户账号",
    exportAccount: "指定用户",
    importAccount: "导入用户",
    createTime:"创建时间",
    name:"广告名称",
    platform:"应用平台",
    term:"有效期",
    accountType:"账户类型",
    isActive:"激活状态",
    userLevel:"账户级别",
    aboutType:"转换度",
    position:"广告位置",
    positionType:"广告类型",
    channel:"渠道",
    adverInfo:"广告详情",
    startTime:"开始时间",
    endTime:"生效时间",
    status:"状态",
    carapace:"马甲包",
    time:"生效",
    param:"适用用户",
    url:"上传图片",
    title:"标题",
    address:"地址",
    content:"内容",
    sort:"排序",
    simulation:"模拟",
    real:"真实",
    demoCaseReal:"真实模拟转换",
    stats:"广告统计",
    positionName:"广告位置名称",
    accountId:"交易账号",
    clickCount: "点击次数",
    clickToOpenCount: "点击人数",
    actionTime:"操作时间",
    deleted: "已刪除",
  },
  analy:{
    dayActive:"当日实时激活数",
    dayReal:"当日真实开户",
    dayDemo:"当日模拟开户",
    dayRealDemo:"当日真实+模拟开户",
    in:"其中",
    dayRealActive:"当天开户并激活数",
    weekActiveCount:"最近7天激活数",
    weekRealCount:"最近7天真实开户数",
    weekDemoCount:"最近7天模拟开户数",
    weekRealDemoCount:"最近7天真实+模拟开户数",
    realCount:"真实开户数",
    demoCount:"模拟开户数",
    realDemoCount:"真实+模拟开户数",
    averCount:"工作日平均线",
    week0:"星期日",
    week1:"星期一",
    week2:"星期二",
    week3:"星期三",
    week4:"星期四",
    week5:"星期五",
    week6:"星期六",
    dayActiveRate:"当日实时激活来源渠道占比",
    dayRealRate:"当日实时真实开户来源渠道占比",
    dayDemoRate:"当日实时模拟开户来渠道占比",
    dayRealDemoRate:"当日实时真实+模拟来源渠道占比",
    dayRealCount:"当日实时真实开户数",
    dayDemoCount:"当日实时模拟开户数",
    dayRealDemoCount:"当日实时+模拟真实开户数",
    today:"今天",
    yesterday:"昨天",
    activeCount:"激活数",
  },
  smsType:{
    device:"页面端",
    type:"验证码方式",
    updateTime:"修改时间",
    modify:"切换方式"
  },
  emailTemplate:{
    emailTemplate:"邮件模板",
    templateName:"模板名称",
    title:"邮件标题",
    enabled:"状态",
    updateDate: '更新时间',
  },
  emailSend:{
    sendEmail:"发送邮件",
    title:"邮件标题",
    sendCount:"发送数量",
    sucCount:"成功数量",
    failCount:"失败数量",
    updateDate: '更新时间',
    sendType:"发送类型",
    chooseTemplate:"模板选择",
    content:"邮件内容",
    receiver:"收件人",
    uploadReceiver:"上传电邮名单",
    emailList:"电邮名单",
    uploadTip:'将文件拖到此处，或',
    uploadTip1:'点击上传',
    uploadTip2:'1、多个邮箱英文逗号隔开',
    uploadTip3:'2、每次上传将覆盖之前邮箱',
    uploadTip4:'3、每次发送不能超过5千个邮箱，超过可分开多次发送',
    uploadTip5:'4、电邮名单只支援.txt或.csv档案格式',
    uploadTip6:'1、附件只支援.pdf档案格式',
    uploadTip7:'2、附件每个大小不能超过10MB',
    uploadSuc:'文件上传成功',
    uploadFail:'文件上传失败',
    uploadFile:'立即上传',
    attachment:'附件',
    selectAttachment:'选择附件',
    deleteAll:'全部刪除',
    chooseChannel:"通道选择",
    sender:"寄件人",
    emailId: "邮件ID",
    customerEmailAddress: "客户邮箱号",
    actionDatetime: "操作时间",
    emailStats: "邮件数据统计",
    statsDetails: "数据详情",
    openRate: "打开率",
  },
  emailChannel:{
    emailChannel:"邮件通道",
    channelName:"通道名称",
    emailAddress:"电邮地址",
    enabled:"状态",
    updateDate: '更新时间',
    senderName: "發件人名稱",
    smtpHost: "SMTP Host",
    smtpPort: "SMTP Port",
    smtpUser: "SMTP User",
    smtpPassword: "SMTP Password"
  },
  optional:{
    iCodeId: "code",
    symbol: "产品编码",
    platform: "平台",
    businessType: "业务组",
    accountNo: "账号",
    account: "用户",
    createTime: "创建时间",
    channel: "渠道",
  },
};
